var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-06-27
 * @brief SEI 종합 Report 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, curConsultingState, curReportState, curTotalState, mainState, reportTypeState, } from "../../../recoil/assessmentState";
import { loadingBoxState } from "../../../recoil/menuState";
import { infoPop, reLoad, reloadSpg, userInfoLoginState } from "../../../recoil/userState";
// utils
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import * as FILEUTILS from "../../../utils/file/fileUtil";
import EhpPagination from "../../common/pagination/EhpPagination";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
// 압축 다운로드
import axios from "axios";
import JSZip from "jszip";
import { langId, langState } from "../../../recoil/langState";
import { useTrans } from "../../../utils/langs/useTrans";
function ReportTotal(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const langs = useRecoilValue(langState); // recoil langState
    const langIds = useRecoilValue(langId);
    const recoilData = useRecoilValue(curReportState);
    const recoilEnergyData = useRecoilValue(curConsultingState);
    const [reloadspg, setReloadspg] = useRecoilState(reloadSpg);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curTotalState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    const [totalMemo, setTotalMemo] = useState(false);
    const [listMemo, setListMemo] = useState(null);
    const [repop, setRepop] = useState(false);
    //props
    const { handleOpenPop, isMobile, is1650M, treeSel } = props;
    const [toogle, setToogle] = useState(false);
    const [treeItem, setTreeItem] = useState([]);
    const [reportItem, setReportItem] = useState([]);
    const [averageToogle, setAverageToogle] = useState(false);
    const [curTree, setCurTree] = useState(null);
    // 페이징
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 검색
    const searchFieldList = [
        { id: 1, sfDisp: t("라벨.레포트명"), sfVal: "title" },
        { id: 2, sfDisp: t("라벨.메모"), sfVal: "totalComment" },
    ];
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: "",
    });
    const [searchInit, setSerarchInit] = useState(searchFieldList[0]);
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "createdTime",
        sort: "desc",
    });
    const dateTermList = [
        { id: 0, dtDisp: t("라벨.직접입력"), dateFormats: "null", dtVal: 0 },
        { id: 1, dtDisp: t("라벨.T_월", ["1"]), dateFormats: "month", dtVal: 1 },
        { id: 2, dtDisp: t("라벨.T_월", ["3"]), dateFormats: "month", dtVal: 3 },
        { id: 3, dtDisp: t("라벨.T_월", ["6"]), dateFormats: "month", dtVal: 6 },
        { id: 4, dtDisp: t("라벨.T_년", ["1"]), dateFormats: "year", dtVal: 1 },
    ];
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateSel, setDateSel] = useState(null);
    const [searchCount, setSearchCount] = useState({
        startDate: null,
        endDate: null,
    });
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    // 등록 팝업
    useEffect(() => {
        //검색
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchFieldList: searchFieldList, searchText: searchText, setSearchText: setSearchText, setSearchTextField: setSearchTextField }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, { checkArr: checkArr, setCheckItem: setCheckItem, setCheckArr: setCheckArr }));
        //공유
        handleOpenPop("pop-share", _jsx(SharePop, { checkItem: checkItem, setCheckItem: setCheckItem, setCheckArr: setCheckArr, repop: repop, setRepop: setRepop, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => PopClose("pop-share") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        // 메모 등록/수정
        handleOpenPop("pop-memo-r2", _jsx(MemoPop, { totalMemo: totalMemo, setTotalMemo: setTotalMemo, listMemo: listMemo, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.종합정밀점검리포트메모") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => MemoPopClose("pop-memo-r2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [searchText, checkArr, checkItem, repop, totalMemo, listMemo]);
    //  닫기
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        setRepop(true);
    }
    function MemoPopClose(id) {
        CUTIL.jsclose_Popup(id);
        setTotalMemo(true);
    }
    // Tree API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/company/filter`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds.toString(),
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                if (!recoilTreeData.companyId) {
                    let companyInfo = recoilEnergyData.companyId
                        ? data.body.filter((comf) => comf.companyId == recoilEnergyData.companyId)
                        : recoilData.companyId
                            ? data.body.filter((comf) => comf.companyId == recoilData.companyId)
                            : data.body;
                    let curComapy = companyInfo.filter((item) => item.companyId == recoilState.companyId).length > 0
                        ? companyInfo.filter((item) => item.companyId == recoilState.companyId)[0]
                        : companyInfo[0];
                    setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { companyId: curComapy.companyId, companyName: curComapy.companyName, id: curComapy.id }));
                    setRecoilState({
                        companyId: curComapy.companyId,
                        zoneId: "",
                    });
                }
                setTreeItem(data.body);
                // 초기화
                if (!reloadspg) {
                    const today = new Date();
                    setStartDate(dayjs(today)
                        .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                        .toDate());
                    setEndDate(today);
                    setDateSel(dateTermList[4].dtVal);
                    setSearchCount({
                        startDate: dayjs(today)
                            .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                            .toDate(),
                        endDate: today,
                    });
                    handleCurPage(0);
                    setSearchText("");
                    setSearchTextField({
                        searchField: "",
                        searchText: "",
                    });
                    setSerarchInit(searchFieldList[0]);
                    setSortData({
                        sortField: "createdTime",
                        sort: "desc",
                    });
                    setCheckItem([]);
                    setCheckArr([]);
                }
                else {
                    setReloadspg(false);
                }
            }
            else {
                // data.body.map((err) => (err.msg));
            }
            setRecoilIsLoadingBox(false);
        }
    }, [data, reloadspg, langIds]);
    // 회사
    function CompanyClick(item) {
        setRecoilTreeData({
            companyId: item.companyId,
            companyName: item.companyName,
            id: item.id,
        });
        setRecoilState({
            companyId: item.companyId,
            zoneId: "",
        });
        if (recoilTreeData.companyId !== item.companyId) {
            setReloadspg(true);
        }
        setToogle(false);
    }
    // 날짜 기간조회
    function handleDayPop(days) {
        const today = new Date();
        if (days.dateFormats == "year") {
            setStartDate(dayjs(today)
                .set("year", dayjs(today).year() - days.dtVal)
                .toDate());
            setEndDate(today);
        }
        else if (days.dateFormats == "month") {
            setStartDate(dayjs(today)
                .set("month", dayjs(today).month() - days.dtVal)
                .toDate());
            setEndDate(today);
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setDateSel(days.id);
    }
    //조회 클릭
    function onClickSearchFilter(e) {
        if (!startDate && endDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "시작 일자를 입력하세요" }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
        else if (!endDate && startDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "종료 일자를 입력하세요" }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
        else {
            handleCurPage(0);
            setCurTree(recoilTreeData);
            setSearchCount({
                startDate: startDate,
                endDate: endDate,
            });
        }
    }
    // 검색 선택
    function SelectClick(item) {
        if (searchInit !== item) {
            setSearchText("");
            setSerarchInit(item);
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        var schDiv = document.getElementById("mcheck_searchinput");
        var isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            const searchVal = {
                text: searchText,
                setSearch: setSearchTextField,
            };
            CUTIL.onClickSearch(searchVal);
        }
        else {
            CUTIL.jsopen_m_Popup(e);
        }
        handleCurPage(0);
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // PDF다운로드
    function handleZipDownload(e) {
        if (checkArr.length < 2) {
            checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
                // HTTPUTIL.fileDownload_WithPdfViewer(list.itemReportDto.serialNo, list.reportId, userInfo.loginInfo.token) // PDFView 링크이동
                HTTPUTIL.fileDownload_EhcReport(`${t("REPORT.종합")}_${list.title}`, list.reportId, userInfo.loginInfo.token);
            }));
        }
        else {
            let zipList = [];
            let zips = new JSZip();
            let zipCnt = 0;
            const zipFileName = `${t("REPORT.종합")}_${recoilTreeData.companyName}_${dayjs(new Date()).format("YYYYMMDD")}.zip`;
            checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
                //await sleep(5000);
                yield getSecondFileUrl(list)
                    .then((val) => {
                    if (val.codeNum === 200) {
                        zipList = zipList.concat({
                            fileName: `${t("REPORT.종합")}_${list.title}_${dayjs(list.updatedTime).format("HH:mm:ss")}.PDF`,
                            fileLink: val.body.fileLink,
                        });
                    }
                    return {
                        codeNum: val.codeNum,
                        fileName: `${t("REPORT.종합")}_${list.title}_${dayjs(list.updatedTime).format("HH:mm:ss")}.PDF`,
                        fileLink: val.body.fileLink,
                    };
                })
                    .then((val) => {
                    if (val.codeNum === 200) {
                        axios({
                            method: "GET",
                            url: val.fileLink,
                            responseType: "blob",
                        })
                            .then((resp) => {
                            zips.file(val.fileName, resp.data);
                            zipCnt++;
                            return zipCnt;
                        })
                            .then((zipCnt) => {
                            if (zipCnt === checkItem.length) {
                                zips.generateAsync({ type: "blob" }).then(function (blob) {
                                    FILEUTILS.saveToFile_Chrome(zipFileName, blob); // 공유 연결시 해당 부분 변경
                                });
                            }
                        });
                    }
                });
            }));
        }
        setCheckItem([]);
        setCheckArr([]);
    }
    function getSecondFileUrl(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/report/${list.reportId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function MobileToogle(e) {
        if (!toogle) {
            setToogle(true);
            // CUTIL.selectFoucs("m" + recoilTreeData.id);
        }
        else {
            setToogle(false);
        }
    }
    const companyOpen = (e) => {
        CUTIL.onClickSelect(e, CUTIL.selectOption);
        CUTIL.selectFoucs(recoilTreeData.id, { num: 0 });
    };
    // 평가 점수 토글 아웃포커싱
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("tooltip-link") || targetElement.closest(".tooltip-link");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".tooltip-link");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("click");
                setAverageToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    // 트리 이외 다른곳 닫기
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("select__toggleBtn") || targetElement.closest(".select__toggleBtn");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select__toggleBtn");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
                setToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsxs("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: [_jsx("div", Object.assign({ className: "flex-inline gap-24 m-none" }, { children: _jsxs("div", Object.assign({ className: "select subZone", onClick: (e) => companyOpen(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTreeData.companyName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: treeItem &&
                                            treeItem.map((item, idx) => (_jsxs("li", Object.assign({ className: `option ${item.id == recoilTreeData.id ? "active" : ""}`, id: item.id, onClick: (e) => CompanyClick(item), title: item.companyName }, { children: [item.companyName, " "] }), "userTree_" + idx.toString()))) })] })) })), _jsx("div", Object.assign({ className: `select__toggleBtn ${toogle ? "active" : ""} `, onClick: (e) => MobileToogle(e) }, { children: _jsx("p", { children: recoilTreeData.companyName }) })), _jsx("div", Object.assign({ className: `box selectbar menutype ${toogle ? "active" : ""}` }, { children: _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: treeItem &&
                                        treeItem.map((item, idx) => (_jsx("li", Object.assign({ className: `${recoilTreeData.id == item.id ? "on" : ""}`, id: "m" + item.id, onClick: (e) => CompanyClick(item) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: item.companyName }) })) }), "userTree_M" + idx.toString()))) })) })) }))] })), _jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements == 0 ? "nodata" : ""}` }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "search" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("span", { children: _jsx("strong", { children: t("라벨.조회기간") }) }), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "searchterm" }, { children: [_jsxs("div", Object.assign({ className: "select term__month", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !reloadspg ? dateTermList[4].dtDisp : t("라벨.직접입력") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: dateTermList.map((dt, idx) => (_jsx("li", Object.assign({ id: "date_" + dt.id, className: "option", onClick: (e) => handleDayPop(dt) }, { children: dt.dtDisp }), `dt_${idx.toString()}`))) })] })), _jsxs("div", Object.assign({ className: "term__date" }, { children: [_jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: startDate, maxDate: endDate ? endDate : new Date(), withPortal: isMobile ? true : false, onChange: (date) => setStartDate(date), onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false }), _jsx("span", Object.assign({ className: "centerline" }, { children: "~" })), _jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: endDate, minDate: startDate, maxDate: new Date(), withPortal: isMobile ? true : false, onChange: (date) => setEndDate(date), onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false })] }))] })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: (e) => onClickSearchFilter(e) }, { children: _jsx("span", { children: t("라벨.조회") }) }))] }) })) })) })), _jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsxs("div", Object.assign({ className: "right" }, { children: [_jsxs("div", Object.assign({ className: "searcharea m-none" }, { children: [_jsxs("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select search", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !reloadspg ? searchFieldList[0].sfDisp : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ id: "selects" + idx, onClick: (e) => SelectClick(sf), className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct w200" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] })), _jsxs("div", Object.assign({ className: "btn__wrap" }, { children: [_jsxs("div", Object.assign({ className: "searcharea m-block" }, { children: [_jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !reloadspg ? searchFieldList[0].sfDisp : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ id: "selects" + idx, onClick: (e) => SelectClick(sf), className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct w200" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.직접입력") }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) }))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-blue js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic js-open", "data-pop": "pop-share", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.공유") }) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic js-open", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.삭제") }) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic", onClick: (e) => handleZipDownload(e) }, { children: _jsxs("span", { children: ["PDF ", t("라벨.다운로드")] }) }))] }))] })) })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("REPORT.NODATA_종합") })), recoilTreeData.companyId && (_jsx(TotalList, { recoilTreeData: recoilTreeData, is1650M: is1650M, isMobile: isMobile, sortData: sortData, setSortData: setSortData, searchCount: searchCount, setSearchCount: setSearchCount, searchTextField: searchTextField, startDate: startDate, setStartDate: setStartDate, endDate: endDate, setEndDate: setEndDate, dateSel: dateSel, setDateSel: setDateSel, dateTermList: dateTermList, pageInfo: pageInfo, setPageInfo: setPageInfo, handleCurPage: handleCurPage, reportItem: reportItem, setReportItem: setReportItem, checkItem: checkItem, setCheckArr: setCheckArr, checkArr: checkArr, setCheckItem: setCheckItem, averageToogle: averageToogle, setAverageToogle: setAverageToogle, treeSel: treeSel, curTree: curTree, setListMemo: setListMemo }))] }))] })) }));
}
export default ReportTotal;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function TotalList(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reload = useRecoilValue(reLoad);
    const setPopInfo = useSetRecoilState(infoPop);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [report, setReport] = useRecoilState(reportTypeState);
    const langIds = useRecoilValue(langId);
    //props
    const { recoilTreeData, is1650M, isMobile, sortData, setSortData, searchCount, searchTextField, pageInfo, setPageInfo, handleCurPage, reportItem, setReportItem, checkItem, setCheckArr, checkArr, setCheckItem, averageToogle, setAverageToogle, treeSel, curTree, setListMemo, } = props;
    let appPath = `companyId=${recoilTreeData.companyId}`;
    appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    // // 조회 기간
    if (!CUTIL.isnull(searchCount.startDate) && !CUTIL.isnull(searchCount.endDate)) {
        appPath =
            appPath +
                `&startDate=${dayjs(searchCount.startDate).format("YYYYMMDD")}` +
                `&endDate=${dayjs(searchCount.endDate).format("YYYYMMDD")}`;
    }
    // 검색 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=${searchTextField.searchText}`;
    }
    // 기기목록 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment/totalreports?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            setRecoilIsLoadingBox(true);
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data.codeNum == CONST.API_200) {
                setReportItem(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
            }
            setRecoilIsLoadingBox(false);
        }
        else {
            // alert(data.errorList.map((err) => (err.msg)));
        }
        // };
    }, [data, is1650M, reload, isMobile, langIds]);
    // 정렬 버튼 액션
    function onClickSort(e, sort) {
        if (e.target.nodeName !== "P") {
            // list 수정
            handleCurPage(0);
            const sortVal = {
                field: sort,
                data: sortData,
                setData: setSortData,
            };
            CUTIL.onClickSort(sortVal);
        }
    }
    function CheckedAll(checked) {
        if (checked) {
            const checks = checkItem.concat(reportItem.filter((checks) => checks.reportId));
            var unique = checks.filter((item, pos) => checks.indexOf(item) === pos);
            const checksId = checkArr.concat(reportItem.filter((checks) => checks.reportId).map((item) => item.id));
            var uniqueId = checksId.filter((item, pos) => checksId.indexOf(item) === pos);
            setCheckArr(uniqueId);
            setCheckItem(unique);
        }
        else {
            let reportItemId = reportItem.filter((checks) => checks.reportId).map((item) => item.id);
            setCheckItem(checkItem.filter((item) => !reportItemId.includes(item.id)));
            setCheckArr(checkArr.filter((item) => !reportItemId.includes(item)));
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        if (checked) {
            setCheckItem([...checkItem, list]);
            setCheckArr([...checkArr, list.id]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el.id !== list.id));
            setCheckArr(checkArr.filter((el) => el !== list.id));
        }
    }
    // 평가 점수 토글
    function 평균점수Info(e) {
        if (averageToogle) {
            setAverageToogle(false);
        }
        else {
            setAverageToogle(true);
        }
    }
    function ReportView(item) {
        setReport(Object.assign(Object.assign({}, report), { checkType: "view", smenu: "total", totalInfo: {
                title: item.title,
                totalId: item.id,
            } }));
    }
    function MemoListPop(e, list) {
        CUTIL.jsopen_Popup(e);
        setListMemo(list);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uADF8\uB8F9,\uC810\uAC80\uD56D\uBAA9,\uCE21\uC815\uC7A5\uBE44,\uC785\uB825\uBC29\uC2DD,\uAC00\uC911\uCE58,\uC810\uAC80\uAC00\uC774\uB4DC,\uCF54\uB4DC,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8  \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "sm-none" }, { children: [_jsx("col", { style: { width: "3%" } }), _jsx("col", { style: { width: "42%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "17%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "8%" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left w3p" }, { children: [_jsx("input", { type: "checkbox", id: "st_all", checked: checkArr.length === 0
                                                    ? false
                                                    : reportItem.filter((checks) => checks.reportId).length ==
                                                        reportItem.filter((list) => checkArr.includes(list.id)).length
                                                        ? true
                                                        : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "st_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "title" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort(e, "title") }, { children: _jsx("span", { children: t("라벨.레포트명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "countItem" && sortData.sort === "desc" ? "desc" : "asc"} m-none`, onClick: (e) => onClickSort(e, "countItem") }, { children: _jsx("span", { children: t("라벨.설비수") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "createdTime" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort(e, "createdTime") }, { children: _jsx("span", { children: t("라벨.생성일자") }) })), _jsxs("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "totalScore" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort(e, "totalScore") }, { children: [_jsxs("div", Object.assign({ className: "tooltip-wrap m-none" }, { children: [_jsx("p", { className: `tooltip-link right-m-90 ${averageToogle ? "click" : ""}`, onClick: (e) => 평균점수Info(e), "data-tooltip": averageToogle ? t("툴팁.평가점수") : "" }), _jsx("span", { children: t("라벨.평가점수") })] })), _jsx("div", Object.assign({ className: "tooltip-wrap m-block" }, { children: _jsx("span", { children: t("라벨.점수") }) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sm-none` }, { children: _jsx("span", { children: t("라벨.메모") }) }))] }) }), _jsx("tbody", { children: reportItem.length > 0 &&
                                reportItem.map((list, idx) => (_jsxs("tr", { children: [_jsxs("td", { children: [_jsx("input", { type: "checkbox", disabled: list.reportId > 0 ? false : true, id: "st_" + idx, checked: checkArr.includes(list.id) ? true : false, onChange: (e) => CheckedList(e.target.checked, list), style: { display: "none" } }), _jsx("label", Object.assign({ htmlFor: "st_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] }), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.title ? list.title : "-" })) })), _jsx("td", Object.assign({ className: "m-none", onClick: (e) => ReportView(list) }, { children: list.countItem ? list.countItem : "-" })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: list.updatedTime ? dayjs(list.createdTime).format("YYYY-MM-DD") : "-" })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: `score-level${list.alarmStatus == "SAFETY" ? "safety" : list.alarmStatus == "WARNING_SCORE" ? "danger" : ""}` }, { children: list.totalScore !== null ? list.totalScore : "-" })) })), _jsx("td", Object.assign({ className: "sm-none" }, { children: _jsx("button", Object.assign({ type: "button", className: `btn btn-comment m-0 js-open ${!list.memo ? "icon-gray" : ""}`, "data-pop": "pop-memo-r2", onClick: (e) => MemoListPop(e, list) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBA54\uBAA8" })) })) }))] }, "totalReort_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "TOTALS", pageInfo: pageInfo, handleCurPage: handleCurPage, checked: checkArr })] }));
}
function SearchPop(props) {
    const t = useTrans();
    // props
    const { searchFieldList, searchText, setSearchText, setSearchTextField } = props;
    const [searchBoolean, setSearchBoolean] = useState(false);
    // 모바일 취소 이벤트 및 초기화
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
        setSearchText("");
        setSearchTextField({
            searchField: searchFieldList[0].sfVal,
            searchText: "",
        });
        setSearchBoolean(true);
    }
    // 진입 시 초기화 이벤트
    useEffect(() => {
        setSearchBoolean(false);
    }, [searchBoolean]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            handleGoSearch(e);
        }
    }
    function handleGoSearch(e) {
        const searchVal = {
            id: "pop-search-small",
            text: searchText,
            setSearch: setSearchTextField,
        };
        CUTIL.onClickSearch(searchVal);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "form__input mb-0" }, { children: [_jsxs("div", Object.assign({ className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !searchBoolean ? searchFieldList[0].sfDisp : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList
                                        .filter((sf) => sf.sfVal !== "panelName")
                                        .map((sf, idx) => (_jsx("li", Object.assign({ className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), `sf_${idx.toString()}`))) })] })), _jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => handleGoSearch(e) }, { children: _jsx("span", { children: t("라벨.적용") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    //props
    const { checkArr, setCheckItem, setCheckArr } = props;
    function Delete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            for (let i = 0; i < checkArr.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/assessment/totalreport/${checkArr[i]}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
            }
            if (data) {
                setReload(true);
                CUTIL.jsclose_Popup("pop-delete");
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_NONE, divTag: data.body }));
                setCheckItem([]);
                setCheckArr([]);
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uB9AC\uD3EC\uD2B8\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => Delete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function SharePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curTotalState);
    // props
    const { checkItem, setCheckItem, setCheckArr, treeSel, repop, setRepop } = props;
    useEffect(() => {
        if (repop) {
            shareClose("pop-share");
        }
    }, [repop]);
    //
    const [toMails, setToMails] = useState("");
    const [errorList, setErrorList] = useState([]);
    function shareClose(id) {
        CUTIL.jsclose_Popup(id);
        setToMails("");
        setErrorList([]);
    }
    function handleSetUserId(e) {
        setErrorList([]);
        setToMails(e.target.value);
    }
    // PDF다운로드
    function handleZipDownload(e) {
        let zipList = [];
        let zips = new JSZip();
        let zipCnt = 0;
        const zipFileName = `${t("REPORT.종합")}_${recoilTreeData.companyName}_${dayjs(new Date()).format("YYYY-MM-DD")}.zip`;
        setRecoilIsLoadingBox(true);
        checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
            //await sleep(5000);
            yield getSecondFileUrl(list)
                .then((val) => {
                if (val.codeNum === 200) {
                    zipList = zipList.concat({
                        fileName: `${t("REPORT.종합")}_${list.title}_${dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss")}.PDF`,
                        fileLink: val.body.fileLink,
                    });
                }
                return {
                    codeNum: val.codeNum,
                    fileName: `${t("REPORT.종합")}_${list.title}_${dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss")}.PDF`,
                    fileLink: val.body.fileLink,
                };
            })
                .then((val) => {
                if (val.codeNum === 200) {
                    axios({
                        method: "GET",
                        url: val.fileLink,
                        responseType: "blob",
                    })
                        .then((resp) => {
                        zips.file(val.fileName, resp.data);
                        zipCnt++;
                        return zipCnt;
                    })
                        .then((zipCnt) => {
                        if (zipCnt === checkItem.length) {
                            zips.generateAsync({ type: "blob" }).then(function (blob) {
                                const email = { email: toMails };
                                linkShare(zipFileName, email, blob); // 공유 연결시 해당 부분 변경
                            });
                        }
                    });
                }
            });
        }));
    }
    function getSecondFileUrl(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/report/${list.reportId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function linkShare(zipFileName, email, content) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(email)], { type: "application/json" });
            formData.append("email", blob);
            formData.append("file", content, zipFileName);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/assessment/report/zip/email`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                    shareClose("pop-share");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList == null ? CONST.ERROR_MSG : data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input w85p" }, { children: _jsxs("li", Object.assign({ className: "center" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "E-Mail" })), _jsxs("div", Object.assign({ className: "input__area w260" }, { children: [_jsx("input", { type: "text", id: "userId0", placeholder: "공유하실 이메일주소를 입력하세요.", className: errorList.filter((err) => err.field === "email").length > 0 ||
                                            errorList.filter((err) => err.field === "mail").length > 0
                                            ? "input-error"
                                            : "", value: toMails, onChange: (e) => handleSetUserId(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "email").length > 0
                                            ? errorList.filter((err) => err.field === "email").map((err) => err.msg)
                                            : errorList.filter((err) => err.field === "mail").length > 0 &&
                                                errorList.filter((err) => err.field === "mail").map((err) => err.msg) }))] }))] })) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => shareClose("pop-share") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => handleZipDownload(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function MemoPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reload, setReload] = useRecoilState(reLoad);
    // props
    const { listMemo, totalMemo, setTotalMemo } = props;
    // state
    const [reportMemo, setReportMemo] = useState("");
    useEffect(() => {
        // 메모 유무의 따른 이벤트
        if (listMemo) {
            setReportMemo(listMemo.memo ? listMemo.memo : "");
        }
        // 닫기의 따른 이벤트
        if (totalMemo) {
            MemoClose("pop-memo-r2");
            setTotalMemo(false);
        }
    }, [listMemo, totalMemo]);
    function MemoClose(id) {
        CUTIL.jsclose_Popup(id);
        setReportMemo(listMemo.memo ? listMemo.memo : "");
    }
    function MemoUpdate(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/totalreport/${listMemo.id}`,
                appQuery: {
                    memo: reportMemo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: ` ${listMemo.memo ? t("라벨.내용이수정되었습니다") : t("라벨.내용이등록되었습니다")} ` }));
                    MemoClose("pop-memo-r2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-memo-r2", type: CONST.TYPE_INNRE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-memo-r2");
                }
                setRecoilIsLoadingBox(false);
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.리포트메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h170", value: reportMemo, onChange: (e) => setReportMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setReportMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [reportMemo ? reportMemo.length : 0, " / 400"] }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => MemoClose("pop-memo-r2") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => MemoUpdate(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
